import React from 'react';
import Flex from '../flex/flex';
import { Icon } from '../icon';
import Label from '../label/label';
import { ITableHeaderCell } from './table.model';
import cx from 'classnames';
import styles from './table.module.scss';

const TableHeaderCell = (props: ITableHeaderCell) => {
  const { children, className, align = 'left', sort, tabIndex, label = '' } = props;

  const sortItem = cx(styles.handleSort, {
    [styles.active]: sort?.active,
  });

  return (
    <th className={className} align={align}>
      <Flex container alignItems="center">
        <Label size="sm">{children}</Label>
        {sort && (
          <button tabIndex={tabIndex} className={sortItem} onClick={() => sort.handleSort(sort.param)}>
            {!sort.active && <Icon content="sortList" />}
            {sort.active && (sort.direction === 'asc' ? <Icon content="sortAsc" /> : <Icon content="sortDesc" />)}
          </button>
        )}
      </Flex>
    </th>
  );
};

export default TableHeaderCell;

TableHeaderCell.displayName = 'Table.HeaderCell';
